'use client';

import { ErrorBoundaryPage } from '@/components/shared/error-boundary-page';

export default function LearnBondingCurvesError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}): React.ReactNode {
  return <ErrorBoundaryPage {...props} component="LearnBondingCurves" />;
}
